import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { CURRENT_SCAN_KEY } from './lib/api';
import '@fontsource-variable/source-sans-3';
// wdth variant carries both weight and width axes: display headings use the
// width axis (font-stretch) for briefing-document authority.
import '@fontsource-variable/archivo/wdth.css';
import '@fontsource-variable/jetbrains-mono';
import './index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false }
  }
});

// The scan result is written via setQueryData (not useQuery), so the
// CURRENT_SCAN_KEY entry has zero observers from the moment it's seeded.
// With the default gcTime of 5 minutes, that means a user sitting on
// the results page for a few minutes loses their scan when they click
// any link, because ScanLayout reads via getQueryData and redirects to
// "/" if undefined. Pin this key so it survives in-memory until a new
// scan overwrites it (or the tab is refreshed).
qc.setQueryDefaults(CURRENT_SCAN_KEY, {
  gcTime: Infinity,
  staleTime: Infinity
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
